<template>
  <div class="v2_box_teal">
    <div class="v2_box_teal_header">
      <b-row>
        <b-col cols="12" sm="9" md="5">
          <div class="d-flex align-items-center h-100">
            <b-button
              class="v2_button_collapse_white v2_color_white text-decoration-none"
              v-b-toggle="collapseId"
              variant="link"
            >
              <span class="when-closed when">
                <i class="mdi mdi-chevron-down" />
              </span>
              <span class="when-opened when">
                <i class="mdi mdi-chevron-up" />
              </span>
            </b-button>
            <div class="d-flex align-items-center flex-column flex-md-row">
              <h2
                class="v2_color_white v2_font_size_24 v2_font_weight_semibold text_underline clickable"
                v-b-toggle="collapseId"
              >
                {{ profile.title }}
              </h2>
              <div
                class="v2_color_white v2_font_size_20  ml-0 ml-lg-3 d-flex align-items-center"
              >
                <i class="mdi mdi-briefcase-check-outline" aria-hidden="true" />
                <span class="ml-1">
                  {{ numberOfMatches }} matches
                  <span class="no-wrap">
                    ({{ numberOfPerfectMatches }} perfect,
                    {{ numberOfCoreMatches }} core)
                  </span>
                </span>
              </div>
            </div>
          </div>
        </b-col>
        <b-col
          cols="12"
          sm="3"
          md="2"
          class="d-flex justify-content-start justify-content-md-center mt-2 mt-sm-0"
        >
          <span
            class="d-flex align-items-center clickable"
            v-b-toggle="collapseId"
          >
            <i
              v-if="numberOfNewMessages === 0"
              class="mdi mdi-mailbox v2_color_white v2_font_size_40 v2_line_height_24"
            />
            <template v-else>
              <i
                class="mdi mdi-mailbox-up v2_color_white v2_font_size_40 v2_line_height_24"
              />
              <span
                class="v2_font_size_20 v2_font_weight_semibold"
              >
                ({{ numberOfNewMessages }})
              </span>
            </template>
          </span>
        </b-col>
        <b-col
          cols="12"
          sm="12"
          md="5"
          class="d-flex align-items-center justify-content-center justify-content-md-end mt-2 md-0"
        >
          <div class="d-flex justify-content-center align-items-center h-100">
            <b-button
              :to="`/exchange/job-profile/${profile.id}`"
              class="mr-3 d-flex align-items-center justify-content-center"
              variant="v2_primary"
            >
              Edit
            </b-button>
            <b-button
              class="d-flex align-items-center justify-content-center"
              variant="v2_primary"
              @click="onDeleteJobProfile"
              :disabled="deleteLoading"
            >
              <template v-if="!deleteLoading">Delete</template>
              <template v-else>
                <b-spinner small />
              </template>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>
    <b-collapse :id="collapseId" accordion="ico-cards">
      <b-row class="py-3 px-1 px-md-2 px-lg-4">
        <b-col v-if="matches.length === 0" cols="12" class="py-4">
          There are no matches for this ICO at this time.
        </b-col>
        <b-col
          v-else
          cols="12"
          v-for="(match, i) in matches"
          :key="match.id"
          :class="{ 'mt-3': i > 0 }"
        >
          <job-profile-job-offer-list-item
            ref="listItems"
            :job-profile="profile"
            :job-questions="jobQuestions"
            :match="match"
            @update-new-msg-count="updateNumberOfNewMsgs"
          />
        </b-col>
      </b-row>
    </b-collapse>
  </div>
</template>

<script>
import JobProfileJobOfferListItem from '@/components/exchange/job-profiles-list/JobProfileJobOfferListItem';
import Help from '@/providers/Help';

export default {
  name: 'JobProfileCard',
  components: {
    JobProfileJobOfferListItem,
  },
  props: {
    profile: {
      type: Object,
      required: true,
    },
    jobQuestions: Array
  },
  data: function () {
    return {
      deleteLoading: false,
      numberOfNewMessages: 0,
    };
  },
  mounted: function () {
    this.updateNumberOfNewMsgs();
  },
  computed: {
    collapseId: function () {
      return `job-profile-${this.profile.id}`;
    },
    numberOfViews: function () {
      return Math.floor(Math.random() * 31);
    },
    numberOfMatches: function () {
      return this.profile.jobProfileJobOfferMatchesCount || 0;
    },
    numberOfCoreMatches: function () {
      return this.profile.jobProfileJobOfferCoreMatchesCount || 0;
    },
    numberOfPerfectMatches: function () {
      return this.profile.jobProfileJobOfferPerfectMatchesCount || 0;
    },
    isDemoMode: function () {
      return this.$store.getters.isDemoMode;
    },
    user: function () {
      return this.$store.state.user ? this.$store.state.user : {};
    },
    isDemoUser: function () {
      return !!this.user.is_demo;
    },
    matches: function () {
      return this.profile.jobProfileJobOfferMatches &&
        Array.isArray(this.profile.jobProfileJobOfferMatches)
        ? this.profile.jobProfileJobOfferMatches
        : [];
    },
  },
  methods: {
    onDeleteJobProfile: function () {
      Help.confirm.show(
        'Are you sure you want to delete the Job Profile?',
        'Delete',
        () => {
          this.deleteJobProfile();
        }
      );
    },
    deleteJobProfile: function () {
      this.deleteLoading = true;
      this.$emit('delete-job-profile', this.profile.id);
    },
    updateNumberOfNewMsgs: function () {
      if (!Array.isArray(this.$refs.listItems)) return;
      this.numberOfNewMessages = this.$refs.listItems.reduce((acc, item) => {
        if (item && item.numberOfUnviewedMessages) {
          acc += parseInt(item.numberOfUnviewedMessages);
        }
        return acc;
      }, 0);
    },
  },
};
</script>

<style scoped lang="scss">
.job-question-and-response-wrapper {
  margin-right: -40px;
}
</style>
